/**
 * @deprecated Use useAsset instead. This is provided for backwards compatibility.
 */
export { useAsset as useWriteup, type Asset as Writeup } from "./use-asset";
